import { useContext } from 'react';
import { EnvContext } from '../../contexts/environment.context';
import { 
  EnvItemContainer, 
  ItemDetails,
  CheckedIcon,
  UncheckedIcon,
  ClientIcon,
  ManageIcon,
  EnvIconContainer,
  EnvIconCodeText
 } from './EnvListItem.styles';

const EnvListItem = ( {envItem, ...otherProps} ) => {

  const { selectedEnvironment } = useContext(EnvContext);
  const {code, environmentName, managedBy} = envItem;

  return (
    <EnvItemContainer>
      <EnvIconContainer>
        {managedBy === "Client"  ? (
          <ClientIcon />
        ) : (
          <ManageIcon />
        )}
        <EnvIconCodeText>{code}</EnvIconCodeText>
      </EnvIconContainer>
      <ItemDetails>
        <span>{environmentName}</span>
      </ItemDetails>
      {selectedEnvironment === code ? (
          <CheckedIcon />
        ) : (
          <UncheckedIcon />
        )}
    </EnvItemContainer>
  );
};

export default EnvListItem;